// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c53937e2","160":"18a2fa1d","208":"00ef1d6a","293":"b4a5eac2","516":"370eae34","519":"81895262","917":"d64213bb","946":"cf9c29ba"}[chunkId] + ".chunk.js";
};